module.exports = __webpack_public_path__ + "static/img/5772_phase_function_Paper_Points.fe32095.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/5772_phase_function_Paper_Points.png
// module id = YH52
// module chunks = 0